<template>
    <div
        class="card calendar-menu"
        v-if="this.openMenu"
        v-bind:style="{ transform: `translateY(${currentY}px)` }"
    >
        <div class="calendar-menu__grabber-container"
            v-on:touchstart="handleTouchStart"
            v-on:touchmove="handleTouchMove"
            v-on:touchend="handleTouchEnd"
        >
            <div class="calendar-menu__grabber"></div>
        </div>
        <date-picker
            v-model="selectedDate"
            v-on:input="changeDate"
            v-bind:lang="{ formatLocale }"
            format="X"
            type="date"
            valueType="format"
            range
            inline
        ></date-picker>
        <div class="calendar-close-btn-container">
            <button class="filter-close-btn" v-on:click="handleCloseBtnClick">
                {{ $t('common.close') }}
            </button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapState } from 'vuex';

const locales = {
    ru: {
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        weekdaysShort: ['Вос', 'Пон', 'Вт', 'Ср', 'Чет', 'Пят', 'Суб'],
        weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    },
    en: {
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    },
};

export default {
    props: ['toggleMenu', 'openMenu'],
    data() {
        return {
            startY: 0,
            currentY: 0,
            moving: false,
            selectedDate: [undefined, undefined],
            formatLocale: undefined,
        };
    },
    computed: {
        ...mapState(['appLocale', 'datePickerFilter']),
    },
    mounted() {
        this.setLocale();
    },
    watch: {
        appLocale() {
            this.setLocale();
        },
        datePickerFilter() {
            // Reset date
            if (!this.datePickerFilter[0] && !this.datePickerFilter[1]) {
                this.selectedDate = [undefined, undefined];
            }
        },
    },
    methods: {
        setLocale() {
            this.formatLocale = locales[this.appLocale];
        },
        changeDate(date) {
            const day = 60 * 60 * 24;
            this.$store.commit('setDatePickerFilter', [Number(date[0]), Number(date[1]) + day]);
        },
        handleTouchStart(event) {
            this.startY = event.touches[0].clientY;
            this.currentY = 0;
        },
        handleTouchMove(event) {
            const touchY = event.touches[0].clientY;
            const deltaY = touchY - this.startY;
            if (deltaY > 0) {
                this.currentY = deltaY;
            } else {
                this.currentY = 0;
            }
        },
        handleTouchEnd() {
            if (this.currentY >= 170) {
                this.toggleMenu();
            }
            this.currentY = 0;
        },
        handleCloseBtnClick() {
            this.toggleMenu();
        },
    },
    components: { DatePicker },
};
</script>

<style lang="scss">
.calendar-menu {
    position: absolute;
    top: 47px;
    right: 0;
    width: auto;
    z-index: 90001;
    padding-bottom: 20px;

    &__card {
        padding: 16px;
    }

    &__grabber-container {
        width: 100%;
        height: 15px;
        margin: 12px 0;
        align-items: center;
        justify-content: center;
        display: none;
    }
    &__grabber {
        width: 40px;
        height: 5px;
        border-radius: 5px;
        background-color: var(--card-border-color);
        position: absolute;
        content: "";
    }
}

@media screen and (max-width: 599px) {
    .calendar-menu__grabber-container {
        display: flex;
    }
}

.calendar-months {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--card-row-separator);
    &__item {
        width: 14.2%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--body-muted-text-color);
    }
}
.calendar-days {
    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    &__item {
        width: 14.2%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    &__item:hover {
        background: var(--modal-dark-background);
        border-radius: 12px;
    }
    &__item-other {
        color: var(--body-muted-text-color);
    }
    &__item-active, &__item-active:hover {
        background: var(--blue-bright);
        color: #fff;
        border-radius: 12px;
    }
}
.calendar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    &__title {
        font-size: 16px;
        line-height: 35px;
        font-weight: 600;
    }
    &__left-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            width: 12px;
        };
    }
    &__right-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            width: 12px;
        };
    }
}
@media screen and (max-width: 599px) {
    .calendar-menu {
        position: fixed;
        top: auto;
        bottom: 0;
        right: 0;
        width: 100%;
        z-index: 90001;
        padding-bottom: 0;
        border-radius: 12px 12px 0 0!important;
    }
}

// Calendar styles
.calendar-menu {
    padding-bottom: 0;
    border-radius: 12px;
}

.mx-datepicker-main {
    font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;
    background-color: transparent;
    border: none;
    color: var(--body-text-color);
}

.mx-calendar + .mx-calendar {
    border-left: 1px solid var(--card-border-color);
}

.mx-table-date {
    th {
        border-bottom: 1px solid var(--card-border-color);
    }
    .cell.not-current-month {
        color: var(--body-muted-text-color);
    }
    .today {
        color: var(--blue-bright);
        //background-color: var(--body-light-muted-color);
        //border-radius: 35px!important;
    }
    .cell {
        border-radius: 6px;
    }
    .cell.in-range,
    .cell.hover-in-range {
        color: var(--body-text-color);
        background-color: var(--body-light-muted-color);
        border-radius: 0;
    }
    .cell.active {
        border-radius: 6px;
        background-color: var(--blue-bright);
        color: white;
    }
    .cell.active:hover {
        color: white;
        background-color: var(--blue-bright);
    }

    /* Start of range */
    .cell.active:has(+ .in-range),
    .cell.active:has(+ .hover-in-range),
    .cell.active:has(+ .cell.active),
    .cell:hover:has(+ .hover-in-range){
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    /* End of range */
    .in-range + .cell.active,
    .cell.active + .cell.active,
    .hover-in-range + .cell:hover {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .cell:hover {
        color: var(--body-text-color);
        background-color: var(--body-light-muted-color);
    }
}

.mx-btn {
    color: var(--body-muted-text-color);

    &:hover {
        border-color: var(--blue-bright);
        color: var(--blue-bright);
    }
}

@media screen and (max-width: 599px) {
    .mx-calendar {
        width: 100%;
    }
    .mx-calendar + .mx-calendar {
        border-left: none;
        border-top: 1px solid var(--card-border-color);
    }
}
.mx-calendar.mx-calendar-panel-date:nth-of-type(2) {
    display: none;
}

.calendar-close-btn-container {
    box-sizing: border-box;
    padding: 0 16px 16px;
}
</style>
